export default "/static/image/asset/arrow.webp"